import {IAppState} from "../store";
import {isOsDark} from "../../theme/ThemeProvider";

const isDark = (store: IAppState) => store.theme.mode === 'dark' || (store.theme.mode === 'auto' && isOsDark())

const selectors = {
    isDark
}

export default selectors